import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'
import Datepicker from 'vuejs-datepicker'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

import HolidayRepository from '@/shared/http/repositories/configuration/holiday'
import HolidayModel from '@/shared/models/configuration/holidaymodel'
import HolidayForms from './holiday-form'

export default {
  name: 'Holidays',
  mixins: [ActionsForm],
  data () {
    return {
      data: HolidayModel,
      form: HolidayForms,
      en: en,
      es: es,
      ptBR: ptBR
    }
  },
  components: {
    Cfg,
    Datepicker
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      HolidayRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      HolidayRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      HolidayRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      HolidayRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/holiday/holiday.js